<div class="mat-elevation-z8">

  <mat-table [dataSource]="dataSource" matSort>
    <!-- acciones -->
    <ng-container matColumnDef="reply">
      <mat-header-cell *matHeaderCellDef [ngClass]="'mw-75'"></mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mw-75'">
        <button (click)="markMensaje(element.mensaje)" *ngIf="!element.mensaje.mensajeLeido && canActionated()"
                mat-icon-button matTooltip="Marcar como leído">
          <mat-icon>
            <fa-icon icon="envelope-open"></fa-icon>
          </mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="viewAttachment">
      <mat-header-cell *matHeaderCellDef [ngClass]="'mw-75'"></mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mw-75'">
        <button (click)="viewAttachment(element.mensaje)" *ngIf="!!element.mensaje.mensajeAdjuntoId && canActionated()"
                mat-icon-button matTooltip="Ver Adjunto">
          <mat-icon>
            <fa-icon icon="paperclip"></fa-icon>
          </mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- fecha -->
    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef [ngClass]="'mw-100'" mat-sort-header>Fecha</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mw-100'">{{element.fecha}}</mat-cell>
    </ng-container>
    <!-- autor -->
    <ng-container matColumnDef="autor">
      <mat-header-cell *matHeaderCellDef [ngClass]="'mw-200'" mat-sort-header>De</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mw-200'">{{element.autor}}</mat-cell>
    </ng-container>
    <!-- contenido -->
    <ng-container matColumnDef="contenido">
      <mat-header-cell *matHeaderCellDef>Mensaje</mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'td-ws-pw'">{{element.contenido}}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>

